import { ChevronUp, ChevronDown, Trash2 } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { PlatformIcon } from "@/features/identity/components/PlatformIcon";
import { SuggestionButton } from "@/features/identity/components/SuggestionButton";
import { getPlatform } from "@/features/identity/constants/platforms";
import { linkSuggestion, LIMITS } from "@/features/identity/validation";

export function LinkRow({ row, index, total, error, onUpdate, onRemove, onMove }) {
  const p = getPlatform(row.platform);
  const k = row.platform;
  const suggestion = error ? linkSuggestion(row.platform, row.url) : null;
  return (
    <li data-testid={`link-row-${k}`} className="mw-fade rounded-lg border border-border bg-card p-4 sm:p-5">
      <div className="flex items-center gap-3">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md border border-border bg-background">
          <PlatformIcon platform={k} />
        </span>
        <span className="font-medium">{p.label}</span>
        <label className="ml-auto flex min-h-[44px] cursor-pointer items-center gap-3 text-xs text-muted-foreground">
          <span data-testid={`link-visibility-label-${k}`}>{row.is_visible ? "Visible" : "Hidden"}</span>
          <Switch checked={row.is_visible} onCheckedChange={(v) => onUpdate({ is_visible: v })} data-testid={`link-visibility-toggle-${k}`} aria-label={`Show ${p.label} link`} />
        </label>
      </div>
      <input
        type="url"
        inputMode="url"
        value={row.url}
        maxLength={LIMITS.url}
        placeholder={p.placeholder}
        onChange={(e) => onUpdate({ url: e.target.value })}
        aria-label={`${p.label} URL`}
        aria-invalid={Boolean(error)}
        data-testid={`link-url-input-${k}`}
        className={`mw-input mt-4 ${error ? "border-destructive focus:border-destructive" : ""}`}
      />
      {error && <p data-testid={`link-url-error-${k}`} className="mt-2 text-xs text-destructive">{error}</p>}
      {suggestion && <SuggestionButton value={suggestion} onApply={(v) => onUpdate({ url: v })} testId={`link-url-suggestion-${k}`} />}
      <div className="mt-3 flex items-center justify-end gap-1">
        <button type="button" onClick={() => onMove(-1)} disabled={index === 0} data-testid={`link-move-up-${k}`} aria-label={`Move ${p.label} up`} className="mw-icon-btn">
          <ChevronUp className="h-4 w-4" />
        </button>
        <button type="button" onClick={() => onMove(1)} disabled={index === total - 1} data-testid={`link-move-down-${k}`} aria-label={`Move ${p.label} down`} className="mw-icon-btn">
          <ChevronDown className="h-4 w-4" />
        </button>
        <button type="button" onClick={onRemove} data-testid={`link-remove-${k}`} aria-label={`Remove ${p.label}`} className="mw-icon-btn hover:text-destructive">
          <Trash2 className="h-4 w-4" />
        </button>
      </div>
    </li>
  );
}
